import { ObservableArray, View } from "binder"
import { SidebarItemViewModel } from "./sidebarItem-viewModel"

export class SidebarItemView extends View<SidebarItemViewModel>{
    GetViewUniqueId(): string {
        return "V-65ECE636-0C4B-4FCF-AC3E-36A108345B2B"
    }
    loadHtml(): string {
        let element = require('./sidebarItem.html').default;
        let style = require('./sidebarItem.less');
        return element;
    }
    constructor() {
       super();
    }

    private _iconPlaceHolder:HTMLElement;
    onRenderCompleted(){
        this._iconPlaceHolder = this.firstlevelElement.querySelector('.V-65ECE636-0C4B-4FCF-AC3E-36A108345B2B-icon-place');
        if(this.className)
            this._iconPlaceHolder.classList.add(this.className);
    }
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set className(v: string) { 
        if(this.className && this._iconPlaceHolder){
            this._iconPlaceHolder.classList.remove(this.className);
        }
        this._className = v; 
        if(this.className && this._iconPlaceHolder){
            this._iconPlaceHolder.classList.add(this._className);
        }
    } public get className(): string { return this._className;} private _className: string;
    public set children(v: ObservableArray<SidebarItemViewModel>) { this._children = v; } public get children(): ObservableArray<SidebarItemViewModel> { return this._children;} private _children: ObservableArray<SidebarItemViewModel>;
    public set command(v: ()=>void) { this._command = v; } public get command(): ()=>void { return this._command;} private _command: ()=>void;
    
    public set isActive(v: boolean) { this._isActive = v; } public get isActive(): boolean { return this._isActive;} private _isActive: boolean;
    public set isExpanded(v: boolean) { this._isExpanded = v; } public get isExpanded(): boolean { return this._isExpanded;} private _isExpanded: boolean;
    public set isExpandable(v: boolean) { this._isExpandable = v; } public get isExpandable(): boolean { return this._isExpandable;} private _isExpandable: boolean;
    
    choose(e){
        this.dataContext.choose();
        e.stopPropagation();
    }
}
